import React, { useEffect, useRef } from "react";
import { initWorkbench } from "./helpers";

// Interactive hero workbench. Renders the static scaffold in JSX, then hands
// the root element to `initWorkbench` which wires up drawer, drag/drop, node
// repositioning, edge drawing, and the cost ticker.
export default function MiniWorkbench({ className = "" }) {
  const rootRef = useRef(null);

  useEffect(() => {
    if (!rootRef.current) return undefined;
    const cleanup = initWorkbench(rootRef.current);
    return cleanup;
  }, []);

  return (
    <div ref={rootRef} className={`wb ${className}`.trim()}>
      <div className="wb-topbar">
        <div className="wb-top-left">
          <span className="wb-dots"><span></span><span></span><span></span></span>
        </div>
        <div className="wb-tabs">
          <span className="wb-tab is-active">Design</span>
          <span className="wb-tab">Code</span>
          <span className="wb-tab">Estimate</span>
          <span className="wb-tab">Review</span>
        </div>
        <div className="wb-top-right">
          <span className="wb-repo">
            <span className="wb-repo-ic" aria-hidden="true">◉</span>
            <span className="wb-repo-name">acme/infra-platform</span>
            <span className="wb-repo-sep">/</span>
            <span className="wb-repo-state">live.state</span>
            <span className="wb-repo-branch">platform/refactor</span>
          </span>
          <div className="wb-region">
            <span className="wb-region-pill">us-east-1 <i className="caret">▾</i></span>
          </div>
        </div>
      </div>

      <div className="wb-body">
        <nav className="wb-rail" aria-label="Tools">
          <button className="wb-rail-btn is-on" title="Select"><span>↖</span></button>
          <button className="wb-rail-btn" title="Pan"><span>✋</span></button>
          <button className="wb-rail-btn is-active" title="Add resource"><span>+</span></button>
          <button className="wb-rail-btn" title="Delete"><span>🗑</span></button>
          <span className="wb-rail-sep"></span>
          <button className="wb-rail-btn" title="Undo"><span>⟲</span></button>
          <button className="wb-rail-btn" title="Redo"><span>⟳</span></button>
          <span className="wb-rail-sep"></span>
          <button className="wb-rail-btn" title="Zoom in"><span>⊕</span></button>
          <button className="wb-rail-btn" title="Zoom out"><span>⊖</span></button>
          <button className="wb-rail-btn" title="Fit"><span>⛶</span></button>
          <span className="wb-rail-zoom">100%</span>
          <span className="wb-rail-sep"></span>
          <button className="wb-rail-btn" title="Lock"><span>🔒</span></button>
          <button className="wb-rail-btn" title="Grid"><span>▦</span></button>
          <button className="wb-rail-btn" title="Layers"><span>▤</span></button>
          <button className="wb-rail-btn" title="Export"><span>↧</span></button>
        </nav>

        <aside className="wb-drawer" id="wbDrawer">
          <header className="wb-drawer-head">
            <div><h4>Add Cloud Resource</h4></div>
            <button className="wb-drawer-close" aria-label="Close">✕</button>
          </header>
          <div className="wb-drawer-filters">
            <div className="wb-pill-select">
              <span className="wb-flag" aria-hidden="true">☁</span>
              <span>AWS</span>
              <i className="caret">▾</i>
            </div>
            <div className="wb-pill-select wb-pill-version">
              <span>6.41.0</span>
              <i className="caret">▾</i>
            </div>
          </div>
          <div className="wb-search">
            <span aria-hidden="true">⌕</span>
            <input placeholder="Search by name or type" />
          </div>
          <div className="wb-drawer-list" id="wbDrawerList"></div>
        </aside>

        <div className="wb-stage">
          <div className="wb-canvas" id="wbCanvas">
            <svg className="wb-edges" id="wbEdges" preserveAspectRatio="none"></svg>
          </div>
        </div>
      </div>

      <footer className="wb-ticker" id="wbTicker">
        <span className="wb-ticker-logo" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18"><path d="M13 2L4 14h7l-2 8 11-14h-7l2-6z" fill="currentColor"/></svg>
        </span>
        <div className="wb-stat is-primary" data-stat="projected">
          <span className="wb-stat-label">PROJECTED <b>MONTHLY</b></span>
          <span className="wb-stat-value" id="wbProj">$39.36/<i>mo</i></span>
        </div>
        <div className="wb-stat" data-stat="annual">
          <span className="wb-stat-label">ANNUAL</span>
          <span className="wb-stat-value" id="wbAnnual">$472.38</span>
        </div>
        <div className="wb-stat" data-stat="direct">
          <span className="wb-stat-label">DIRECT</span>
          <span className="wb-stat-value" id="wbDirect">$38.83</span>
        </div>
        <div className="wb-stat" data-stat="implied">
          <span className="wb-stat-label">IMPLIED</span>
          <span className="wb-stat-value is-implied" id="wbImplied">+$0.53</span>
        </div>
        <div className="wb-stat" data-stat="count">
          <span className="wb-stat-label">RESOURCES</span>
          <span className="wb-stat-value" id="wbCount">11</span>
        </div>
        <div className="wb-chips">
          <span className="wb-chip is-ok">✓ 5 policies</span>
          <span className="wb-chip is-fail">✕ 1 failed</span>
          <span className="wb-chip is-ok">✓ Quotas OK</span>
        </div>
      </footer>
    </div>
  );
}
